// extracted by mini-css-extract-plugin
export default {"container":"ClientValidatorErrorDisplayer_container__fJJT-","errorMsg":"ClientValidatorErrorDisplayer_errorMsg__+oyrh"};